/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  IssuanceProfileChoice,
  IssuanceProfileChoice$Outbound,
  IssuanceProfileChoice$outboundSchema,
} from "./issuanceprofilechoice.js";

export type SetIssuanceProfileRequestBody = {
  /**
   * Every choice the profile should hold. With mcp_server_id, the choice for that server alone, or none to remove it.
   */
  choices: Array<IssuanceProfileChoice>;
  /**
   * Limits the write to this MCP server: the profile's choices for other servers are kept as they are.
   */
  mcpServerId?: string | undefined;
  /**
   * The profile's name.
   */
  name: string;
  /**
   * The OAuth client, for a client's profile.
   */
  userSessionClientId?: string | undefined;
  /**
   * The sign-in.
   */
  userSessionIssuerId: string;
  /**
   * The workload issuer, for a workload's profile.
   */
  workloadIssuerId?: string | undefined;
  /**
   * The workload subject, for a workload's profile.
   */
  workloadSubject?: string | undefined;
};

/** @internal */
export type SetIssuanceProfileRequestBody$Outbound = {
  choices: Array<IssuanceProfileChoice$Outbound>;
  mcp_server_id?: string | undefined;
  name: string;
  user_session_client_id?: string | undefined;
  user_session_issuer_id: string;
  workload_issuer_id?: string | undefined;
  workload_subject?: string | undefined;
};

/** @internal */
export const SetIssuanceProfileRequestBody$outboundSchema: z.ZodMiniType<
  SetIssuanceProfileRequestBody$Outbound,
  SetIssuanceProfileRequestBody
> = z.pipe(
  z.object({
    choices: z.array(IssuanceProfileChoice$outboundSchema),
    mcpServerId: z.optional(z.string()),
    name: z.string(),
    userSessionClientId: z.optional(z.string()),
    userSessionIssuerId: z.string(),
    workloadIssuerId: z.optional(z.string()),
    workloadSubject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      mcpServerId: "mcp_server_id",
      userSessionClientId: "user_session_client_id",
      userSessionIssuerId: "user_session_issuer_id",
      workloadIssuerId: "workload_issuer_id",
      workloadSubject: "workload_subject",
    });
  }),
);

export function setIssuanceProfileRequestBodyToJSON(
  setIssuanceProfileRequestBody: SetIssuanceProfileRequestBody,
): string {
  return JSON.stringify(
    SetIssuanceProfileRequestBody$outboundSchema.parse(
      setIssuanceProfileRequestBody,
    ),
  );
}
